var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$vuetify.breakpoint.mobile)?_c('v-app-bar-nav-icon',{attrs:{"color":"secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.updateMenuMiniState.apply(null, arguments)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }